import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-current-user-complex-statistics',
    templateUrl: './current-user-complex-statistics.component.html',
    styleUrls: ['../../base/base-statistics-reports.scss'],
    standalone: false
})
export class CurrentUserComplexStatisticsComponent implements OnInit {

  title: string = "pages.currentUserComplexStatistics.title";
  getComplexStatisticsApiMethodName: string = "statisticsGetCurrentUserComplexStatistics";
  getDetailComplexStatisticsApiMethodName: string = "statisticsGetCurrentUserDetailComplexStatistics";
  lineComplexChartId: string = "lineComplex_currentUserComplexStatistics";
  barComplexChartId: string = "barComplex_currentUserComplexStatistics";
  constructor() { }

  ngOnInit(): void {
  }

}
